import { ITaxFormSubmissionResponse } from "@wingspanhq/payments/dist/interfaces/api/taxForm";
import { servicePayments } from "../servicePayments";

export const getTaxFormBySecureLink = async (
  token: string
): Promise<ITaxFormSubmissionResponse> => {
  const { data } = await servicePayments.get(`/tax-form/${token}/secure-link`);
  return data;
};
